import { render } from "./CreateService.vue?vue&type=template&id=00bd58fa&scoped=true"
import script from "./CreateService.vue?vue&type=script&lang=js"
export * from "./CreateService.vue?vue&type=script&lang=js"

import "./CreateService.vue?vue&type=style&index=0&id=00bd58fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bd58fa"]])

export default __exports__